module.exports = __webpack_public_path__ + "media/1701.17ccc6b7.mp3";